<div class="offline-toolbar aker-dark-theme">
  <div class="title">{{ 'Offline mode' }}</div>
  @if (online) {
    <div class="description">- {{ 'Internet connected' }}</div>
  }
  @if (!online) {
    <div class="description">- {{ 'No connection to the internet' }}</div>
  }
  <div class="status">
    <i class="material-icons">{{ online ? 'wifi' : 'wifi_off' }}</i>
  </div>
  <div class="description">{{ 'Offline changes' }}: {{ offlineChanges }}</div>
  <div class="description">
    <i class="material-icons" (click)="fetchPendingCount()" tabindex="0">{{ 'autorenew' }}</i>
  </div>
  @if (online) {
    <div class="switchMode">
      <button mat-flat-button color="primary" (click)="switchToOnline()">
        {{ 'Switch to online' }}
      </button>
    </div>
  }
</div>
